import React from 'react';
import classnames from 'classnames';
import { Card, CardContent } from '@material-ui/core';

type CardColor = 'primary' | 'danger' | 'flash';

interface Cardprops {
  children?: React.ReactNode;
  color?: CardColor;
  className?: string;
  style?: {};
}

const Cards = ({ children, className = 'card', color, style }: Cardprops) => {
  return (
    <Card style={style} className={classnames(className, color)}>
      <CardContent style={style}>{children}</CardContent>
    </Card>
  );
};

interface CardDateProps {
  children?: React.ReactNode;
  color?: CardColor;
  style?: {};
  contentStyle?: {};
}

const CardDate = ({
  children,
  color = 'primary',
  style,
  contentStyle,
}: CardDateProps) => {
  return (
    <Card style={style} className={classnames('card-date', color)}>
      <CardContent style={contentStyle}>{children}</CardContent>
    </Card>
  );
};

export { Cards, CardDate };
